var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    { attrs: { appBarTitle: _vm.toolbarTitle, route: _vm.backRoute } },
    [
      _c(
        "KPageContainer",
        { staticClass: "device-container" },
        [
          _vm.status
            ? _c("ContentWizardUiAlert", { attrs: { errorType: _vm.status } })
            : _vm._e(),
          _vm.status === "" && !_vm.$store.state.core.loading
            ? _c("FilteredChannelListContainer", {
                attrs: {
                  channels: _vm.allChannels,
                  selectedChannels: _vm.selectedChannels,
                  selectAllCheckbox: _vm.multipleMode,
                },
                on: {
                  "update:selectedChannels": function ($event) {
                    _vm.selectedChannels = $event
                  },
                  "update:selected-channels": function ($event) {
                    _vm.selectedChannels = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _vm.status === ""
                            ? _c("h1", { attrs: { "data-test": "title" } }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.multipleMode
                                        ? _vm.$tr("importChannelsHeader")
                                        : _vm.$tr("importResourcesHeader")
                                    ) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "abovechannels",
                      fn: function () {
                        return [
                          _c(
                            "p",
                            [
                              _vm.channelsAreAvailable
                                ? _c("KButton", {
                                    attrs: {
                                      appearance: "basic-link",
                                      text: _vm.multipleMode
                                        ? _vm.$tr("selectTopicsAndResources")
                                        : _vm.$tr("selectEntireChannels"),
                                    },
                                    on: { click: _vm.toggleMultipleMode },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.showUnlistedChannels
                            ? _c("KButton", {
                                attrs: {
                                  "data-test": "token-button",
                                  text: _vm.$tr("channelTokenButtonLabel"),
                                  appearance: "raised-button",
                                  name: "showtokenmodal",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showTokenModal = true
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.$route.query.token
                            ? _c(
                                "div",
                                {
                                  staticClass: "token-chip",
                                  style: {
                                    backgroundColor:
                                      _vm.$themePalette.grey.v_300,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "token-chip-text" },
                                        [_vm._v(_vm._s(_vm.$route.query.token))]
                                      ),
                                      _c("KIconButton", {
                                        staticClass: "token-chip-button",
                                        attrs: { icon: "delete", size: "mini" },
                                        on: { click: _vm.clearToken },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "p",
                            [
                              _c(
                                "UiAlert",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.notEnoughFreeSpace,
                                      expression: "notEnoughFreeSpace",
                                    },
                                  ],
                                  attrs: { dismissible: false, type: "error" },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.deviceString(
                                          "notEnoughSpaceForChannelsWarning"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var showItem = ref.showItem
                        var handleChange = ref.handleChange
                        var itemIsSelected = ref.itemIsSelected
                        return [
                          !_vm.channelsAreAvailable && !_vm.status
                            ? _c("p", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$tr("noChannelsAvailable")) +
                                    "\n        "
                                ),
                              ])
                            : _c(
                                "p",
                                _vm._l(_vm.allChannels, function (channel) {
                                  return _c("ChannelPanel", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          showItem(channel) &&
                                          !_vm.channelIsBeingDeleted(
                                            channel.id
                                          ),
                                        expression:
                                          "showItem(channel) && !channelIsBeingDeleted(channel.id)",
                                      },
                                    ],
                                    key: channel.id,
                                    attrs: {
                                      channel: channel,
                                      onDevice: _vm.channelIsOnDevice(channel),
                                      multipleMode: _vm.multipleMode,
                                      checked: itemIsSelected(channel),
                                    },
                                    on: {
                                      clickselect: function ($event) {
                                        return _vm.goToSelectContentPageForChannel(
                                          channel
                                        )
                                      },
                                      checkboxchange: handleChange,
                                    },
                                  })
                                }),
                                1
                              ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  708926228
                ),
              })
            : _c("KCircularLoader", { staticStyle: { margin: "2em auto" } }),
          _vm.showTokenModal
            ? _c("ChannelTokenModal", {
                attrs: { disabled: _vm.disableModal },
                on: {
                  cancel: function ($event) {
                    _vm.showTokenModal = false
                  },
                  submit: _vm.handleSubmitToken,
                },
              })
            : _vm._e(),
          _vm.showUpdateModal
            ? _c("ChannelUpdateModal", {
                attrs: { disabled: _vm.disableModal },
                on: {
                  cancel: function ($event) {
                    _vm.showUpdateModal = false
                  },
                  submit: _vm.handleConfirmUpgrade,
                },
              })
            : _vm._e(),
          _vm.channelsAreLoading
            ? _c("KLinearLoader", {
                attrs: { type: "indeterminate", delay: false },
              })
            : _vm._e(),
          _vm.multipleMode
            ? _c("SelectionBottomBar", {
                attrs: {
                  objectType: "channel",
                  actionType: "import",
                  disabled:
                    _vm.disableBottomBar ||
                    _vm.selectedChannels.length === 0 ||
                    _vm.notEnoughFreeSpace,
                  selectedObjects: _vm.selectedChannels,
                  fileSize: _vm.fileSize,
                },
                on: {
                  "update:fileSize": function ($event) {
                    _vm.fileSize = $event
                  },
                  "update:file-size": function ($event) {
                    _vm.fileSize = $event
                  },
                  clickconfirm: _vm.handleClickConfirm,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }